var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  "+_vm._s(_vm.invoiceType())+" UPDATED "+_vm._s(_vm.invoiceTotal())+"\n  "),_c('invoice-object',{attrs:{"entity-id":_vm.invoiceId(),"invoice":_vm.$lodash.get(_vm.activity, 'detail.invoice'),"open-new":true}}),_c('pdf-object',{attrs:{"href":_vm.invoicePdf()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }